import appApi from '../../../../../api/app-api';
import { InstallmentReportRow } from '../../../../../api/types/reports/accountant/installment.type';
import { InstallmentsSideBarFilterType } from '../side-bar/installments-side-bar-filter.type';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { toast } from 'react-toastify';

// Helper function to get the start and end of a month
const getMonthStartAndEnd = (
  date: Date,
): { startDate: string; endDate: string } => {
  const year = date.getFullYear();
  const month = date.getMonth();

  // Start of month (1st day at 00:00:00)
  const startDate = new Date(year, month, 1);

  // End of month (last day at 23:59:59)
  const endDate = new Date(year, month + 1, 0);

  return {
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
  };
};

export const getReportInstallmentsOperation = async (
  filters: InstallmentsSideBarFilterType,
  setData: (data: InstallmentReportRow[]) => any,
  setLoading: (loading: boolean) => any,
) => {
  try {
    setLoading(true);

    // Calculate start and end dates from the selected month
    let startDate: string | null = null;
    let endDate: string | null = null;

    if (filters.selectedMonth) {
      const { startDate: start, endDate: end } = getMonthStartAndEnd(
        filters.selectedMonth,
      );
      startDate = start;
      endDate = end;
    }

    const res = await appApi.getInstallmentsReport({
      startDate,
      endDate,
      paymentStatus: filters.paymentStatuses,
    });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    setData(res.data.body);
    setLoading(false);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
